var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FCECEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8702 9.99996L12.8338 8.03632C12.9474 7.92275 12.9474 7.73845 12.8338 7.6247L12.3775 7.16843C12.264 7.05486 12.0797 7.05486 11.9659 7.16843L10.0025 9.13226L8.03882 7.16861C7.92525 7.05504 7.74096 7.05504 7.62721 7.16861L7.17111 7.6247C7.05755 7.73827 7.05755 7.92257 7.17111 8.03632L9.13476 9.99996L7.17111 11.9636C7.05755 12.0772 7.05755 12.2615 7.17111 12.3752L7.62739 12.8315C7.74096 12.9451 7.92525 12.9451 8.039 12.8315L10.0025 10.8677L11.9661 12.8313C12.0797 12.9449 12.264 12.9449 12.3777 12.8313L12.834 12.375C12.9476 12.2615 12.9476 12.0772 12.834 11.9634L10.8702 9.99996Z",
    fill: "#D02B20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x_mark.c170415b128ac374a1f4f9974acdd81d.svg";
export { ForwardRef as ReactComponent };